import { OpenAPI, PatientFileService } from 'common/api';
import { Environment } from 'global/environment';
import { getRequest, serviceRequest } from 'utils/http';

export function getPatientFilesAPI(referralId: string) {
  return serviceRequest(() =>
    PatientFileService.patientFileControllerList(referralId)
  );
}

export function getPatientFileDownloadUrlAPI(
  referralId: string,
  fileId: string
) {
  return serviceRequest(() =>
    PatientFileService.patientFileControllerDownloadUrl(referralId, fileId)
  );
}

export function getPatientFilesArchiveAPI(referralId: string): Promise<Blob> {
  return getRequest(
    `${Environment.BACKEND_API}/referral/${referralId}/patient-files/archive`,
    {
      options: {
        headers: {
          Authorization: `Bearer ${OpenAPI.TOKEN}`,
        },
        responseType: 'blob',
      },
    }
  );
}
